var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('div',{staticClass:"float-left"},[_c('i',{staticClass:"productTypeIcon pt-1 px-1",class:_vm.icon,attrs:{"role":"presentation"}}),_c('span',{staticClass:"count ml-1"},[_vm._v(_vm._s(_vm.count))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }